import { gql } from '@apollo/client';

export const GET_HAS_TMS_LOADING_DETAIL = gql`
    query HasTmsLoadingDetailForPortal($taskId: Long!, $taskWayPointId: Long!) {
        hasTmsLoadingDetailForPortal(taskId: $taskId, taskWayPointId: $taskWayPointId)
    }
`;

export interface HasTmsLoadingDetailResponse {
    hasTmsLoadingDetailForPortal: boolean;
}

export interface HasTmsLoadingDetailVariables {
    taskId: number;
    taskWayPointId: number;
}
